import useLocalStorage from 'use-local-storage';
import {  useDispatch } from 'react-redux'
import { toggleBtn } from '../redux/Feature/toggleSlice'

const ToggleSwitch = ({rounded= false}) => {


    const dispatch = useDispatch();


    // dark theme start
    const defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    const [theme, setTheme] = useLocalStorage('theme', defaultDark ? 'dark' : 'light');

    const switchTheme = () => {
        const newTheme = theme === 'dark' ? 'light' : 'dark';
        setTheme(newTheme);
        dispatch(toggleBtn(theme))
    }

    // dark theme ends

    return (
        <>
            <label className="switch">
                <input type="checkbox" 
                    onChange={switchTheme}
                />
                <span  className={`slider round `}/>
            </label>

               {/* <button onClick={switchTheme} >
                            Switch to {theme === 'light' ? 'Dark' : 'Light'} Theme
                        </button> */}
        </>
    )
}

export default ToggleSwitch